import React, { ReactElement } from 'react';
import { default as ListItem } from '@material-ui/core/ListItem';
import { Hidden } from '@material-ui/core';
import { default as IconButton } from '@material-ui/core/IconButton';
import { default as Tooltip } from '@material-ui/core/Tooltip';
import TranslationHelper from '../../../helpers/TranslationHelper';
import { default as PlusIcon } from '@material-ui/icons/Add';
import { default as ExpandLess } from '@material-ui/icons/ExpandLess';
import { default as ExpandMore } from '@material-ui/icons/ExpandMore';

import { IReport, IReportEntity } from '../../../state/types';
import ReportLabel from '../../../components/report/ReportLabel/ReportLabel';
import ReportEntitiesList from '../../../components/report/ReportEntitiesList/ReportEntitiesList';
import { useStyles } from './Themable.hooks';

interface IOwnProps {
    open: boolean;
    report: IReport;
    openDeletionDialog: (id: string, message?: string | undefined) => void;
    handleExpandClick: () => void;
    addActionHandler: () => void;
    renderListItem: (
        entity: IReportEntity,
        openDeletionDialog: (id: string, message?: string | undefined) => void,
        borderless?: boolean
    ) => void;
    additionalActions?: ReactElement;
}

const ReportList = ({
    open,
    report,
    handleExpandClick,
    addActionHandler,
    renderListItem,
    openDeletionDialog,
    additionalActions,
}: IOwnProps) => {
    const classes = useStyles();

    const weHaveEntities = report.entities?.length > 0;
    const headerless = report._meta?.headerless || false;
    let hasAddAction = false;
    let useVisualHint = false;

    if (report._meta) {
        const meta = report._meta;
        useVisualHint = meta.componentName === 'visualHint';
        if (meta.actions) {
            hasAddAction = meta.actions.add !== undefined;
        }
    }

    return (
        <>
            {!headerless && (
                <ListItem
                    disableGutters={true}
                    className={classes.listItemHeading}
                >
                    <ReportLabel report={report} />
                    {additionalActions}
                    <Hidden smDown={true}>
                        {hasAddAction && (
                            <Tooltip title={TranslationHelper.translate('Add')}>
                                <IconButton onClick={addActionHandler}>
                                    <PlusIcon />
                                </IconButton>
                            </Tooltip>
                        )}
                    </Hidden>
                    <IconButton
                        onClick={handleExpandClick}
                        style={{
                            visibility: weHaveEntities ? 'visible' : 'hidden',
                        }}
                    >
                        {open ? <ExpandLess /> : <ExpandMore />}
                    </IconButton>
                </ListItem>
            )}
            <ReportEntitiesList
                open={open || headerless}
                report={report}
                visualHint={useVisualHint}
                renderListItem={renderListItem}
                openDeletionDialog={openDeletionDialog}
            />
        </>
    );
};

export default ReportList;
